import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { LESSONS_PATH_FRAGMENT, TRACKS_PATH_FRAGMENT, SHORT_CONTENT_PATH_FRAGMENT } from './consts';
const TYPE_TO_PATH_FRAGMENT = {
  LESSON: LESSONS_PATH_FRAGMENT,
  COURSE: TRACKS_PATH_FRAGMENT,
  TRACK: TRACKS_PATH_FRAGMENT,
  SHORT_FORM_CONTENT: SHORT_CONTENT_PATH_FRAGMENT
};
export const getCatalogResourceUrl = resource => {
  const pathFragment = TYPE_TO_PATH_FRAGMENT[resource.type];
  if (!pathFragment) {
    return undefined;
  }
  const portalId = PortalIdParser.get();
  if (!portalId) {
    return undefined;
  }
  return `${getFullUrl('app')}/academy/${portalId}${pathFragment}/${resource.id}`;
};